export function shouldPlayProductVideo(state) {
  return Boolean(
    state.sectionVisible
      && state.documentVisible
      && state.muted
      && state.loop
      && state.playsInline
      && state.autoplay,
  );
}

const elementName = 'aceii-product-media';

if (
  typeof window !== 'undefined'
  && typeof HTMLElement !== 'undefined'
  && !window.customElements.get(elementName)
) {
  class AceiiProductMedia extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.sectionVisible = false;
      this.documentVisible = !document.hidden;
      this.videos = [...this.querySelectorAll('[data-product-video]')];
      const { signal } = this.abortController;

      document.addEventListener(
        'visibilitychange',
        () => {
          this.documentVisible = !document.hidden;
          this.syncVideos();
        },
        { signal },
      );

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.sectionVisible = Boolean(entry?.isIntersecting);
          this.syncVideos();
        },
        {
          rootMargin: '160px 0px',
          threshold: 0.01,
        },
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.pauseAll();
      this.observer?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
    }

    ensureSource(video) {
      if (video.currentSrc || video.src || !video.dataset.src) return;
      video.src = video.dataset.src;
      video.load();
    }

    syncVideos() {
      this.videos.forEach((video) => {
        const canPlay = shouldPlayProductVideo({
          sectionVisible: this.sectionVisible,
          documentVisible: this.documentVisible,
          muted: video.muted,
          loop: video.loop,
          playsInline: video.playsInline,
          autoplay: video.dataset.autoplay === 'true',
        });

        if (!canPlay) {
          if (!video.paused) video.pause();
          return;
        }

        this.ensureSource(video);
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            video.pause();
          });
        }
      });
    }

    pauseAll() {
      this.videos.forEach((video) => {
        if (!video.paused) video.pause();
      });
    }
  }

  window.customElements.define(elementName, AceiiProductMedia);
}
